/**
 * 
 * @param {Array} selects - array/nodelist of select elements
 * @returns {Array} - array of options
 */


const getCurrentSelectedOptionsFromSelects = (selects) => () => [...selects].map(select => select.value)


export default getCurrentSelectedOptionsFromSelects;